import { useContext } from 'react';
import AuthContext from 'client/utils/auth/AuthContext/AuthContext';

export const useAuth = () => useContext(AuthContext);

export default useAuth;
